enum SFDCSourceFileType {
    svmx = 'svmx',
    fsl = 'fsl',
}

export default SFDCSourceFileType;
